// test1083
(1083 && 0);
